let src = ''
src = document.querySelector('html').classList.contains('fromBMO')
  ? 'bmo'
  : document.querySelector('html').classList.contains('fromMG')
  ? 'mg'
  : ''
const selectEl = $(`.jsCompareBrandsSelect`)

const tableEl = $(`.compare-brands__container`)
const rowsEl = tableEl.find(
  '.compare-brands__row:not(.compare-brands__row--name)'
)

function onChange() {
  const val = $(this).val()

  rowsEl.each(function (index, el) {
    // $(el).find('.compare-brands__cell:nth-last-child(-n+2)').hide()
    $(el).find('.compare-brands__cell:nth-last-child(-n+5)').hide()
    $(el).find('.compare-brands__cell').eq(val).show()
  })
}

function handleSelect() {
  if ($(window).width() <= 991) {
    selectEl.niceSelect()
    selectEl.on('change', onChange).trigger('change')
  } else {
    selectEl.niceSelect('destroy')
    tableEl.find('.compare-brands__cell').show()
    selectEl.off('change', onChange)
  }
}

handleSelect()
$(window).on('resize', handleSelect)
